import type { Step } from '@/components/wizard/Step';

import {
  ConnectAwsRestoreAccount,
  type AwsConnectRestoreAccountState,
} from './connectAwsRestoreAccount';
import {
  ConnectAwsSourceAccount,
  type AwsConnectSourceAccountState,
} from './connectAwsSourceAccount';
import {
  ConnectAwsSourceOrganizationUnit,
  type AwsConnectOrganizationUnitState,
} from './connectAwsSourceOrganizationUnit';

export const awsConnectSourceAccountFlow: Step<AwsConnectSourceAccountState> = {
  id: 'connect_aws_source_account',
  Component: ConnectAwsSourceAccount,
};

export const awsConnectSourceOrganizationFlow: Step<AwsConnectOrganizationUnitState> =
  {
    id: 'connect_aws_source_organization',
    Component: ConnectAwsSourceOrganizationUnit,
  };

export const awsConnectRestoreAccountFlow: Step<AwsConnectRestoreAccountState> =
  {
    id: 'connect_aws_restore_account',
    Component: ConnectAwsRestoreAccount,
  };
